import axios from "axios";
import store from "../store";

const base = () => `${process.env.VUE_APP_SAAS_BACK}/tache`;
const headers = () => ({ Authorization: `Bearer ${store.state.jwt}` });

export default {
  async getMapping() {
    const r = await axios.get(`${base()}/mapping`, { headers: headers() });
    return r.data;
  },

  async saveClientMapping(data) {
    const r = await axios.post(`${base()}/mapping/client`, data, { headers: headers() });
    return r.data;
  },

  async deleteClientMapping(uid) {
    const r = await axios.delete(`${base()}/mapping/client/${uid}`, { headers: headers() });
    return r.data;
  },

  async saveUserMapping(data) {
    const r = await axios.post(`${base()}/mapping/user`, data, { headers: headers() });
    return r.data;
  },

  async deleteUserMapping(uid) {
    const r = await axios.delete(`${base()}/mapping/user/${uid}`, { headers: headers() });
    return r.data;
  },

  async getSettings() {
    const r = await axios.get(`${base()}/settings`, { headers: headers() });
    return r.data;
  },

  async saveSettings(data) {
    const r = await axios.put(`${base()}/settings`, data, { headers: headers() });
    return r.data;
  }
};
